import { render, staticRenderFns } from "./DownLoadFulfillment.vue?vue&type=template&id=acc5bfcc"
import script from "./DownLoadFulfillment.vue?vue&type=script&lang=js"
export * from "./DownLoadFulfillment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports